module.exports = __webpack_public_path__ + "img/c6bdc629c8167477bc67a2a1d8a3e50.1d366347.png";